/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


( function( $ ) {
	
	var FilterToplist = {};
	
	FilterToplist.process = function( data ) {
		var type = {name: 'Type', value: 'filter-toplist'};
		var listID = {name: 'ListID', value: $( '#ListID' ).val()};
		
		data.push( type );
		data.push( listID );

		var $btnWrapper = $( '.filter-form .btn-wrapper' );
		var btnText = $btnWrapper.find( '.btn' ).attr( 'value' );

		$btnWrapper.find( '.btn' ).prop( 'disabled', true ).attr( 'value', '' ).css( 'opacity', '0.5' );
		$btnWrapper.append( '<div class="form-loader spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>' );

		$.post(
			'/',
			data,
			function( response ) {
				$( '#ToplistFormContainer' ).hide();
//				$( '#ToplistContainer' ).html( response ).show();
				$( '#ToplistContainer' ).html( response );
				
				if( $( '#ToplistContainer .toplist-row' ).length ) {
					$( '#ToplistContainer .toplist' ).css( 'display', 'block' );
					$( '#ToplistContainer .no-items' ).css( 'display', 'none' );
				} else {
					$( '#ToplistContainer .toplist' ).css( 'display', 'none' );
					$( '#ToplistContainer .no-items' ).css( 'display', 'block' );
				}
				
				$( '#ToplistContainer' ).show();
				
				FilterToplist.initEdit();
				
				if( !window.location.hash ) {
					window.history.pushState( 'filter', null, './#filter' );
				}
				
				$( '#Toplist-modal' ).on( 'show.bs.modal', function( event ) {
					FilterToplist.processModal( event );
				} );
			}
		).done( function() {
			$btnWrapper.find( '.btn' ).prop( 'disabled', false ).attr( 'value', btnText ).css( 'opacity', '1' );
			$btnWrapper.find( '.form-loader' ).remove();

			$( '.usp-banner' ).fadeOut();
			$( '#bank-affiliates' ).fadeOut();

			$( 'html,body' ).animate( {
				scrollTop: 0
			} );
		} );		
	};
	
	FilterToplist.processHistory = function() {
		window.addEventListener( 'popstate', function( e ) {
			if( e.state === 'filter' ) {
				$( '.filter-form' ).submit();
			} else if( e.state === null ) {
				FilterToplist.processEdit();
			}
		} );
	};
	
	FilterToplist.initEdit = function() {
		$( '#EditSearch' ).click( function( e ) {
			e.preventDefault();

			window.history.back();
		} );
	};
	
	FilterToplist.processEdit = function() {
		var navH = $('.navbar-default').height() + $('#wpadminbar').height() +  30;

		$( 'html, body').animate( { scrollTop: $( '#ToplistContainer' ).offset().top - navH } );
		$( '#ToplistContainer' ).html( '' ).hide();
		$( '#ToplistFormContainer' ).show();
		$( '.usp-banner' ).fadeIn();
		$( '#bank-affiliates' ).fadeIn();
	};
	
	FilterToplist.processModal = function( event ) {
		var container = $( '#Toplist-modal' );
		var data = $( event.relatedTarget ).parents( '.toplist-row' ).data();
		
		var uspItemsString = '';

		if( data.usp ) {
			var uspItems = data.usp.split( /<br( |\n)?\/?>/ig );
			
			for( var i = 0; i < uspItems.length; i++ ) {
				if( uspItems[i].trim() === '' ) {
					continue;
				}
				
				uspItemsString += '<div class="modal-list clearfix"><div class="check-icon-holder"><div class="check-icon">' +
						'<div class="check-icon-inner"></div></div></div><h3>' + uspItems[i].replace( /<(?:.|\n)*?>/gm, '' ) + '</h3></div>';
			}
		}

		container.find( '.modal-logo' ).html( '<img src="' + data.logo + '" alt="' + data.name + '" class="img-responsive">' );
		container.find( '.usp' ).html( uspItemsString );
		container.find( '.interest' ).text( data.interest );
		container.find( '.footer-button a' ).prop( 'href', data.link );
		container.find( '.category' ).text( data.criteria );
		container.find( '.example' ).text( data.example );
	};
	
	$( document ).ready( function() {
		$( '#ToplistContainer' ).hide();
		
		$( '#PaymentIssues' ).click( function() {
			if( $( this ).is( ':checked' ) ) {
				$( '#PaymentIssuesUncheck' ).attr( 'disabled', true );
			} else {
				$( '#PaymentIssuesUncheck' ).attr( 'disabled', false );
			}
		} );
		
		$( '.filter-form' ).submit( function( e ) {
			e.preventDefault();
			
			var data = $( this ).serializeArray();
			
			FilterToplist.process( data );
		} );
		
		FilterToplist.processHistory();
		
		$( '#Toplist-modal' ).on( 'show.bs.modal', function( event ) {
			FilterToplist.processModal( event );
		} );
	} );
	
} )( jQuery );